/* istanbul ignore file */
import React, { useCallback } from 'react';
import { useFormContext } from 'framework/form';
import { Button } from 'framework/ui/mui-builder';
import { REQUEST_STATUS } from 'domain/sales/opportunity/presale/request/shared/presaleRequestConstants';
import { Modal } from 'framework/ui/ui-builder';

export interface BeforeSubmitModalProps {
  modalOpen: boolean;
  setModalOpen: any;
}

const BeforeSubmitModal = ({ modalOpen, setModalOpen }: BeforeSubmitModalProps) => {
  const { data = {}, submitForm = () => {} } = useFormContext();

  const onSave = useCallback(
    (status: any) => {
      data.requestStatus = status;
      submitForm();
      setModalOpen(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, submitForm],
  );

  const onClickSubmit = useCallback(() => {
    onSave(REQUEST_STATUS.SUBMITTED);
  }, [onSave]);

  const saveSubmittedButton = (
    <Button data-testid="btn-success" key="modal-submit-button" onClick={onClickSubmit}>
      Submit
    </Button>
  );

  const onClickDraft = useCallback(() => {
    onSave(REQUEST_STATUS.DRAFT);
  }, [onSave]);

  const saveAsDraftButton = (
    <Button data-testid="modal-save-draft-button" key="modal-save-draft-button" onClick={onClickDraft}>
      Save as draft
    </Button>
  );

  return (
    <>
      <Modal
        isOpen={modalOpen}
        title="After you submit the request, the ticket will be assigned to the presale manager"
        hasCancelButton={false}
        buttons={[saveSubmittedButton, saveAsDraftButton]}
        onToggle={() => {
          setModalOpen(false);
        }}
      >
        <span>
          Are you sure you want to submit this request? You can also save the request as a draft and send the presale
          request later.
        </span>
      </Modal>
    </>
  );
};

export default BeforeSubmitModal;
